import Economy from 'us.collection.economy/sagas';
import { PaymentAgreementSagas } from './PaymentAgreement';
import { ObsoleteDateSagas } from './ObsoleteDate';

export default [
  ...Economy,
  ...PaymentAgreementSagas,
  ...ObsoleteDateSagas
]